<script setup lang="ts">
import { ref, computed } from 'vue';
import UiIcon from './UiIcon.vue';
import { UiCardSpreadClasses } from './shared/constants';

type IconVariant = 'chevron' | 'arrow-badge' | 'none';

interface Props {
  open?: boolean;
  /** 'chevron' / 'arrow-badge' render the built-in trigger icon. 'none' suppresses it so the trigger slot can render its own (e.g. inline with a heading). */
  icon?: IconVariant;
  triggerSpread?: 'sm' | 'md' | 'lg' | 'none';
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  icon: 'chevron',
  triggerSpread: 'none'
});

const isOpen = ref(props.open);

const triggerSpreadClass = computed(() => {
  switch (props.triggerSpread) {
    case 'sm':
      return UiCardSpreadClasses.sm;
    case 'md':
      return UiCardSpreadClasses.md;
    case 'lg':
      return UiCardSpreadClasses.lg;
    case 'none':
      return '';
  }
});
</script>

<template>
  <div>
    <div class="flex items-center justify-between cursor-pointer" :class="triggerSpreadClass" @click="isOpen = !isOpen">
      <slot name="trigger" :open="isOpen" />
      <template v-if="props.icon === 'chevron'">
        <UiIcon name="chevron-down" class="w-5 h-5 transition-transform duration-100 ease-in-out" :class="{ '-rotate-90': isOpen }" />
      </template>
      <template v-else-if="props.icon === 'arrow-badge'">
        <span class="inline-flex items-center justify-center rounded-md bg-se-primary p-1.5 ml-2">
          <UiIcon name="arrow-right" class="w-2.5 h-2.5 transition-transform duration-100 ease-in-out" :class="{ '-rotate-45': !isOpen, 'rotate-45': isOpen }" />
        </span>
      </template>
    </div>
    <div
      class="grid transition-all duration-300 ease-in-out"
      :style="{ gridTemplateRows: isOpen ? '1fr' : '0fr' }"
    >
      <div class="overflow-hidden">
        <slot />
      </div>
    </div>
  </div>
 </template>


